<footer class="footer-copyright text-center text-white py-3 open-nav">
  <!-- &copy; 2018 Copyright:
  <a class="text-white" href="http:/mdbootstrap.com/angular/">MDBootstrap.com</a> -->
</footer>